<template>
  <div class="recordPage">
    <div class="recordBg">
      <div class="record">
        <div class="recordC" @scroll="handleScroll">
          <div class="recordScroll">
            <template v-for="(item, index) in recordList">
              <div class="recordLi" :key="index">
                <div class="recordTd" style="width: 47%">
                  {{ formatDateTime(item.receiveTime) }}
                </div>
                <div class="recordTd" style="width: 23%">
                  {{ item.rewardAmount }}
                </div>
                <div class="recordTd" style="width: 30%">
                  {{ item.dispatchStatusDesc }}
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="backArea" @click="back"></div>
    </div>
  </div>
</template>

<script>
import { getHistory } from "@/api/index";

export default {
  name: "Record-vue",
  props: {
    activityId: String,
  },
  data() {
    return {
      recordList: [],
    };
  },
  mounted() {
    this.recordNum = 1;
    this.recordList = [];
    this.isLoadingMore = false;
    this.hasMore = true;
    this.historyRecord();
  },

  methods: {
    // 格式化日期时间
    formatDateTime(timestamp) {
      if (!timestamp) return "";

      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    // 返回抽奖大厅
    back() {
      this.clearRecordTimer();

      this.$emit("back");
    },
    // 红包记录
    historyRecord() {
      if (this.isLoadingMore || !this.hasMore) return;
      this.isLoadingMore = true;

      getHistory({
        activityType: 7,
        pageNo: this.recordNum,
        pageSize: 10,
      }).then((res) => {
        this.recordList.push(...res.rows);
        this.recordNum += 1;
        // 如果新数据长度小于pageSize，则说明没有更多数据
        this.hasMore = res.rows.length === 10;
        this.isLoadingMore = false;
      });
    },
    // 红包记录滚动
    handleScroll(event) {
      event.preventDefault();

      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // 当滚动到底部时加载更多
      if (scrollTop + clientHeight >= scrollHeight - 5 && this.hasMore) {
        this.historyRecord();
      }
    },

    // 清除文字滚动
    clearRecordTimer() {
      clearInterval(this.recordTimer);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.recordPage {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 4;

  .recordBg {
    background: url("../assets/record.png") no-repeat;
    background-size: contain;
    width: 455px;
    height: 721px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .record {
    position: absolute;
    top: 128px;
    left: 52px;

    .recordC {
      width: 381px;
      height: 317px;
      overflow-y: auto;
      position: absolute;
      top: 14px;
      left: -27px;

      .recordScroll {
        width: 100%;

        .recordLi {
          display: flex;
          align-items: center;
          height: 39px;
          border-bottom: 1px solid #fee0ac;

          .recordTd {
            color: #b45252;
            font-size: 17px;
            text-align: center;
          }
        }
      }
    }
  }

  .backArea {
    position: absolute;
    bottom: 5px;
    left: 201px;
    color: #ffffff;
    font-size: 25px;
    cursor: pointer;
    width: 52px;
    height: 52px;
  }

  .turnArea {
    position: absolute;
    bottom: 47px;
    left: 15px;
    width: 510px;
    height: 37px;
    cursor: pointer;
  }
}
</style>
